import { Link } from "react-router-dom";
import AdminPageLayout from "../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../components/midpoint/admin/layout/AdminPageHeader";

export default function DealerPendingPlaceholderPage() {
  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Concesionarios"
        title="Solicitud en revisión"
        description="Recibimos tu solicitud. Nuestro equipo te contactará por WhatsApp."
      />
      <main className="admin-console__main" style={{ padding: "2rem" }}>
        <ol>
          <li>Revisamos tu información de negocio.</li>
          <li>Confirmamos WhatsApp y formato de inventario.</li>
          <li>Activamos tu perfil cuando el inventario esté listo.</li>
        </ol>
        <p>
          <Link to="/v/automap">Volver al inicio</Link>
        </p>
      </main>
    </AdminPageLayout>
  );
}
